module.exports = __webpack_public_path__ + "img/banner.99813096.jpg";